import { useQueryClient } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import Toast from '@/components/ui/Toast/toast';
import { useSocketEvent } from '@/hooks/socket/useSocketEvent';
import openModal from '@/modals/utils/openModal';
import { QueriesKeys } from '../queriesKeys';

export interface AssignedBundleOffer {
  offerId: string;
  productId: string;
  name: string;
  bsc: number;
  gc: number;
  sc: number | null;
}

export interface BundleOfferAssignedPayload {
  userId: string;
  bundleOffers: AssignedBundleOffer[];
}

export function useBundlesSocket() {
  const t = useTranslations('bundles.exclusive-offer-available');
  const queryClient = useQueryClient();

  useSocketEvent<BundleOfferAssignedPayload>(
    'bundle-offer.assigned',
    () => {
      queryClient.refetchQueries({ queryKey: [QueriesKeys.bundleOffers] });

      return (
        Toast({
          type: 'success',
          title: t('title'),
          description: t('description'),
          rejectButtonText: t('reject'),
          acceptButtonText: t('accept'),
          containerClassName: 'max-w-82',
          onAccept: () => {
            openModal('deposit');
            queryClient.invalidateQueries({ queryKey: [QueriesKeys.bundleOffers] });
          },
        })
      );
    },

  );
}
